import {PaginatorMeta} from "@/lib/interfaces/paginator";
import ReactPaginate from "react-paginate";
import "@/styles/paginator.scss";

interface PaginatorProps {
    paginator: PaginatorMeta
    onPageChange?: (event: any) => void
}

export default function Paginator({paginator, onPageChange}: PaginatorProps) {
    return (
        <ReactPaginate
            className={`eo-paginator`}
            pageCount={paginator.last_page}
            onPageChange={onPageChange}
        />
    )
}
